import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// tailwind-merge only knows Tailwind's built-in sizes, so it read our type
// roles (tailwind.config.cjs → theme.extend.fontSize) as text *colours* and
// dropped them whenever a colour followed: cn("text-caption", "text-ink-3")
// lost the size. Registering them keeps size and colour side by side.
export const FONT_SIZE_ROLES = ["display", "title", "section", "card-title", "body", "body-sm", "label", "meta", "caption"] as const;

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: [...FONT_SIZE_ROLES] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const formatFileSize = (bytes: number) => {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
};
